interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function LoadingSpinner({ size = 'md', className = '' }: LoadingSpinnerProps) {
  const sizes = {
    sm: 'h-5 w-5',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  }

  return (
    <div className={`flex items-center justify-center ${className}`}>
      {/* Compass-style spinner */}
      <svg
        className={`animate-spin-slow text-primary-600 ${sizes[size]}`}
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.9391 9.04932L16.8353 15.3596C16.7208 15.7032 16.5278 16.0153 16.2718 16.2714C16.0157 16.5275 15.7036 16.7204 15.36 16.8349L9.04971 18.9387L11.1535 12.6284C11.268 12.2848 11.461 11.9727 11.717 11.7166C11.9731 11.4606 12.2852 11.2676 12.6288 11.1531L18.9391 9.04932Z"
          stroke="currentColor"
          strokeWidth="2.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9944 25.6565C20.4352 25.6565 25.6564 20.4353 25.6564 13.9945C25.6564 7.55378 20.4352 2.33252 13.9944 2.33252C7.55366 2.33252 2.3324 7.55378 2.3324 13.9945C2.3324 20.4353 7.55366 25.6565 13.9944 25.6565Z"
          stroke="currentColor"
          strokeWidth="2.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}

export function FullPageSpinner() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-cream-50">
      <LoadingSpinner size="lg" />
      <p className="mt-4 text-brown-600 font-medium">Loading your adventure...</p>
    </div>
  )
}
